import { WEEK_MOMENTS, checkDay, checkHour } from '../deleteOutHoursDRP'
import { getDayToCall, setTextDependingOnDay } from './dynamicValuesToCallDate'

import { FEEDBACK_MESSAGES, PREFIX_PHONE_LIST } from '../../config'
import { addErrorMsg } from './addErrorMsg'
import { buildPhoneCodes } from './buildPhoneCodes'
import { validationPhoneWithPrefix } from './validationPhoneWithPrefix'

export function englishVersion() {
  const $form = document.getElementById('custom-budget-form')
  const $modalInEnglish = document.querySelector('.custom-budget--en')
  const $explainMsgPhone = document.querySelector('.custom-budget__msg')
  const $phoneInput = $form.querySelector('input[name="telefono"]')

  const TEMPLATES_FOR_DATE_CALL = {
    SET_HOUR: `
      <option selected value="">Select schedule</option>
      <option >Call me ${setTextDependingOnDay()} 9  to 13h</option>
      <option >Call me ${setTextDependingOnDay()} 13 to 15h</option>
      <option >Call me ${setTextDependingOnDay()} 15 to 17h</option>
      <option >Call me ${setTextDependingOnDay()} 17 to 20h</option>
    `
  }

  // SET_HOUR: `
  //     <option selected value="">Select schedule</option>
  //     <option value="${getDayToCall()} 9  to 13h">Call me ${setTextDependingOnDay()} 9  to 13h</option>
  //     <option value="${getDayToCall()} 13 to 15h">Call me ${setTextDependingOnDay()} 13 to 15h</option>
  //     <option value="${getDayToCall()} 15 to 17h">Call me ${setTextDependingOnDay()} 15 to 17h</option>
  //     <option value="${getDayToCall()} 17 to 20h">Call me ${setTextDependingOnDay()} 17 to 20h</option>
  //   `

  if ($modalInEnglish !== null) {
    let nacionalidad = document.getElementById("nationality");

    if(nacionalidad !== null){
      nacionalidad.addEventListener("change", function() {
        handleNationalitySelection();
      });
    };

    function handleNationalitySelection() {
      var selectedNationality = nacionalidad.value;
      console.log("La nacionalidad seleccionada es: " + selectedNationality);
      DFI.labels.EDeclaratives.nacionalidad = selectedNationality;
      // Aquí puedes realizar otras acciones relacionadas con la selección de nacionalidad
    }
    const $selectToCodes = buildPhoneCodes()
    let PREFIX_SELECTED = PREFIX_PHONE_LIST.UK_PHONE

    $selectToCodes.addEventListener('change', (event) => {
      const inputWrap = $selectToCodes.parentElement
      const getError = inputWrap.querySelector('.custom-budget__error')
      getError?.remove()

      if (event.target.value === 'other') {
        addErrorMsg({
          field: 'telefono',
          msg: FEEDBACK_MESSAGES.HOURS.OFFICE_OFF_EN
        })
        $phoneInput.setAttribute('disabled', 'true')
        return
      }

      if ($phoneInput.value !== '') {
        PREFIX_SELECTED = event.target.value
        validationPhoneWithPrefix({
          explainMsgPhone: $explainMsgPhone,
          phoneValue: $phoneInput.value,
          prefixSelected: PREFIX_SELECTED
        })
        $phoneInput.removeAttribute('disabled')
      }
    })

    const callDateSelect = document.getElementById('call_date-select')
    const callDateSelectWrap = document.getElementById('call_date-wrap')
    callDateSelect.innerHTML = TEMPLATES_FOR_DATE_CALL.SET_HOUR

    callDateSelect.addEventListener('change', function() {

      DFI.labels.EDeclaratives.Llamada_programada_AB = callDateSelect.options[callDateSelect.selectedIndex].text;
    })

    // if (
    //   checkHour({
    //     start: 0,
    //     end: 8,
    //     customMinutes: 59
    //   }) ||
    //   checkHour({
    //     start: 20,
    //     end: 23,
    //     customMinutes: 59
    //   }) ||
    //   checkDay() === WEEK_MOMENTS.SATURDAY ||
    //   checkDay() === WEEK_MOMENTS.SUNDAY
    // ) {
    //   callDateSelect.innerHTML = TEMPLATES_FOR_DATE_CALL.SET_HOUR
    // } else {
    //   callDateSelectWrap?.remove()
    // }
  }
}
